import { render, staticRenderFns } from "./current-chat.vue?vue&type=template&id=7fbae15b&scoped=true&"
import script from "./current-chat.vue?vue&type=script&lang=js&"
export * from "./current-chat.vue?vue&type=script&lang=js&"
import style0 from "./current-chat.vue?vue&type=style&index=0&id=7fbae15b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbae15b",
  null
  
)

export default component.exports